// extracted by mini-css-extract-plugin
export default {"Container":"HelpCenter_Container__0MdLh","div1122":"HelpCenter_div1122__dDQ2K"};